import { useState } from 'react';

// Food emoji based on category/cuisine for placeholder
const getFoodEmoji = (recipe) => {
  const categories = recipe?.categories || [];
  const cuisines = recipe?.cuisines || [];
  const title = (recipe?.title || '').toLowerCase();

  // Check categories first
  if (categories.includes('dessert') || title.includes('cake') || title.includes('cookie')) return '🍰';
  if (categories.includes('breakfast') || title.includes('pancake') || title.includes('egg')) return '🍳';
  if (categories.includes('soup') || title.includes('soup') || title.includes('stew')) return '🍲';
  if (categories.includes('salad') || title.includes('salad')) return '🥗';
  if (categories.includes('pasta') || title.includes('pasta') || title.includes('spaghetti')) return '🍝';
  if (categories.includes('pizza') || title.includes('pizza')) return '🍕';
  if (categories.includes('sandwich') || title.includes('sandwich') || title.includes('burger')) return '🍔';
  if (categories.includes('seafood') || title.includes('fish') || title.includes('salmon') || title.includes('shrimp')) return '🐟';
  if (categories.includes('chicken') || title.includes('chicken')) return '🍗';
  if (categories.includes('beef') || title.includes('beef') || title.includes('steak')) return '🥩';
  if (categories.includes('lamb') || title.includes('lamb')) return '🍖';
  if (categories.includes('vegetarian') || categories.includes('vegan')) return '🥬';

  // Check cuisines
  if (cuisines.includes('mexican') || title.includes('taco')) return '🌮';
  if (cuisines.includes('japanese') || title.includes('sushi')) return '🍣';
  if (cuisines.includes('chinese') || title.includes('stir fry')) return '🥡';
  if (cuisines.includes('indian') || title.includes('curry')) return '🍛';
  if (cuisines.includes('italian')) return '🍝';
  if (cuisines.includes('mediterranean') || cuisines.includes('greek')) return '🫒';
  if (cuisines.includes('middle-eastern') || title.includes('flatbread') || title.includes('kofta')) return '🥙';

  // Default
  return '🍽️';
};

// Reusable thumbnail component with error handling
function RecipeThumbnail({ recipe, className = '', size = 'default', showTitle = true }) {
  const [imageError, setImageError] = useState(false);
  const emoji = getFoodEmoji(recipe);

  const sizeClasses = {
    small: 'text-2xl',
    default: 'text-4xl',
    large: 'text-7xl',
  };

  const isLarge = size === 'large' || size === 'default';

  if (!recipe?.thumbnailUrl || imageError) {
    return (
      <div className={`w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-primary-100 to-accent-100 dark:from-primary-900/30 dark:to-accent-900/30 ${className}`}>
        <span className={sizeClasses[size]}>{emoji}</span>
        {showTitle && size !== 'small' && recipe?.title && (
          <span className={`text-gray-600 dark:text-gray-300 mt-3 px-6 text-center ${isLarge ? 'text-lg font-semibold line-clamp-2' : 'text-xs line-clamp-1'}`}>
            {recipe.title}
          </span>
        )}
        {isLarge && recipe?.sourceCreator && (
          <span className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            by {recipe.sourceCreator}
          </span>
        )}
      </div>
    );
  }

  return (
    <img
      src={recipe.thumbnailUrl}
      alt={recipe.title || 'Recipe'}
      className={`w-full h-full object-cover ${className}`}
      onError={() => setImageError(true)}
      loading="lazy"
    />
  );
}

export default RecipeThumbnail;
export { getFoodEmoji };
